
import {makeStyles} from "tss-react/mui";
import {calcRemainingHeight} from "../actions/ui";
const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex'
  },
  typographyHeader: {
    backgroundColor: '#D7DBDD'
  },
  iconList: {
    minWidth: theme.spacing(4)
  },
  shellFilter:
    {
      backgroundColor: 'white',
      maxHeight: calcRemainingHeight('settings-btn', 300),
      overflow: 'auto'
    }
}));
export default useStyles;